import { OrganizationManager } from '../implementation/organization-manager';
import { ORGANISATION_MANAGER_SERVICE } from '../../../../features/organization-create/application/tokens/tokens';

export function provideOrganizationCreateProviders() {
  return [
    { provide: ORGANISATION_MANAGER_SERVICE, useClass: OrganizationManager },
  ];
}
